<template>
	<div class="topbar">
		<div class="topbar-inner">
			<router-link
				:to="{ name: 'Landing' }"
				class="section-logo"
			>
				<img src="@/assets/RediR.png">
			</router-link>
		</div>
	</div>
</template>

<script>
export default {
	name: 'TheVisitorTopbar',
};
</script>

<style lang="scss" scoped>
.topbar {
	.topbar-inner {
		margin-left: auto;
		margin-right: auto;
		width: 100%;
		max-width: 1096px;
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding: $gap-2 $gap-5;
	}
}
</style>
